import { AppBar, Box, Button, FormControl, Grid, Skeleton, Tab, Tabs, Toolbar } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import MenuIcon from '@mui/icons-material/Menu';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import './styles.scss';
import UserIcon from '../Sidebar/icons/UserBlue';
import EngrenagemIcon from '../Sidebar/icons/Engrenagem';
import { ReactComponent as SinoNotificacaoAlertIcon } from '../Sidebar/icons/notification_alert.svg';
import { ReactComponent as SinoNotificacaoIcon } from '../Sidebar/icons/notification.svg';
import useNavBarHook from './useNavBarHook';
import MoreItems from './MoreItems';
import MenuDepartamentosMobile from './MenuDepartamentosMobile';

const Navbar = ({
  menuOpen,
  setMenuOpen,
  setAlertSideBarOpen,
  setUserSideBarOpen,
  onlySmallScreen,
  qtdIconeNotificacao,
  setDepartamentoSelecionado,
  departamentoSelecionado,
  setEscopoAcesso
}) => {
  const {
    isPendingDepartamento,
    mostrarInputPesquisa,
    mostraPesquisaGeral,
    handleChangeTabs,
    valueTab,
    allProps,
    logo,
    itensVisiveis,
    itensMais,
    navegarParaConfiguracoes,
    btnMaisClickado,
    setBtnMaisClickado,
    isPendingMenuPrincipal,
    AutoCompleteCustom,
    menuDepartamentoSideBar,
    setMenuDepartamentoSideBar,
    lstItensDepartamento,
    irParaHome
  } = useNavBarHook({
    setDepartamentoSelecionado,
    departamentoSelecionado,
    setMenuOpen,
    menuOpen,
    setEscopoAcesso
  });

  return (
    <AppBar position="fixed" className="nav-bar-principal">
      {!onlySmallScreen && (
        <Toolbar className="navbar-toolbar">
          <Box
            onClick={() => irParaHome()}
            className="img-logo-main-one7 cursor-pointer"
            style={{
              backgroundImage: `url(${logo})`
            }}
            alt="Logo"
          />

          <Grid container className="grid-tabs">
            {isPendingDepartamento && (
              <Grid item xs={9} sm={9} md={9} lg={10} xl={10} className="pad-left-5">
                <Skeleton variant="text" width="100%" height={15} />
                <Skeleton variant="rectangular" width="100%" height={10} />
                <Skeleton variant="text" width="100%" height={15} />
              </Grid>
            )}

            {!isPendingDepartamento && (
              <>
                <Grid
                  item
                  xs={9}
                  sm={9}
                  md={9}
                  lg={10}
                  xl={10}
                  className={`${mostrarInputPesquisa ? 'display-none' : ''}`}
                >
                  <Box className="box-tabs">
                    <Box className="sub-box">
                      <Tabs value={valueTab} onChange={handleChangeTabs}>
                        {itensVisiveis.map((opcao, index) => {
                          const isSelected = valueTab === index;
                          return (
                            <Tab
                              key={opcao.id}
                              disableRipple
                              disabled={isPendingMenuPrincipal}
                              label={
                                <Box display="flex" alignItems="center" className="hover-texto">
                                  {opcao.label}
                                  {!isSelected && <ExpandMoreIcon className="font-size-20" />}
                                  {isSelected && <ExpandLessIcon className="font-size-20" />}
                                </Box>
                              }
                              {...allProps(opcao.id)}
                            />
                          );
                        })}
                      </Tabs>

                      {itensMais.length > 0 && (
                        <Box ml={1}>
                          <MoreItems
                            itens={itensMais}
                            onSelect={handleChangeTabs}
                            valueTab={valueTab}
                            btnMaisClickado={btnMaisClickado}
                            setBtnMaisClickado={setBtnMaisClickado}
                            departamentoSelecionado={departamentoSelecionado}
                            disabled={isPendingMenuPrincipal}
                          />
                        </Box>
                      )}
                    </Box>
                  </Box>
                </Grid>

                {mostrarInputPesquisa && (
                  <Grid item xs={9} sm={9} md={9} lg={10} xl={10}>
                    <FormControl variant="outlined" className="input-pesquisa-geral">
                      <AutoCompleteCustom />
                    </FormControl>
                  </Grid>
                )}
              </>
            )}

            <Grid item xs={3} sm={3} md={3} lg={2} xl={2} className="flex-box-items-centralizados">
              <Grid container className="texto-cor-cinza-escuro flex-box-items-centralizados">
                <Grid
                  item
                  xs={3}
                  sm={3}
                  md={3}
                  lg={3}
                  xl={2}
                  onClick={() => mostraPesquisaGeral()}
                  className="flex-box-items-centralizados hover-icones"
                >
                  <SearchIcon className="icon-notificacao" />
                </Grid>
                <Grid
                  item
                  xs={3}
                  sm={3}
                  md={3}
                  lg={3}
                  xl={2}
                  onClick={() => setAlertSideBarOpen(true)}
                  className="flex-box-items-centralizados hover-icones"
                >
                  {qtdIconeNotificacao && (
                    <SinoNotificacaoAlertIcon className="icone-sino-notificacao" />
                  )}
                  {!qtdIconeNotificacao && <SinoNotificacaoIcon className="icone-sino-notificacao" />}
                </Grid>
                <Grid
                  item
                  xs={3}
                  sm={3}
                  md={3}
                  lg={3}
                  xl={3}
                  onClick={() => navegarParaConfiguracoes()}
                  className="flex-box-items-centralizados hover-icones engrenagem-icon"
                >
                  <EngrenagemIcon className="icon-notificacao engrenagem-icon" />
                </Grid>
                <Grid
                  item
                  xs={3}
                  sm={3}
                  md={3}
                  lg={3}
                  xl={3}
                  onClick={() => setUserSideBarOpen(true)}
                  className="flex-box-items-centralizados hover-icones nav-icon-user"
                >
                  <UserIcon className="nav-icon-user font-size-10" />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Toolbar>
      )}

      {onlySmallScreen && (
        <Toolbar className="navbar-toolbar-mobile">
          <Grid container className="grid-tabs">
            {!mostrarInputPesquisa && (
              <>
                <Grid item xs={2} sm={2} md={2} className="flex-box items-centralizados">
                  <Button onClick={() => setMenuDepartamentoSideBar(true)}>
                    <MenuIcon className="menu-icon-btn" />
                  </Button>
                </Grid>

                <Grid item xs={6} sm={6} md={6}>
                  <Box
                    onClick={() => irParaHome()}
                    className="img-logo-main-one7 cursor-pointer"
                    style={{
                      backgroundImage: `url(${logo})`
                    }}
                    alt="Logo"
                  />
                </Grid>
              </>
            )}

            {mostrarInputPesquisa && (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <FormControl variant="outlined" className="input-pesquisa-geral">
                  <AutoCompleteCustom />
                </FormControl>
              </Grid>
            )}

            {!mostrarInputPesquisa && (
              <>
                <Grid
                  item
                  xs={2}
                  sm={2}
                  md={2}
                  lg={2}
                  xl={2}
                  onClick={() => mostraPesquisaGeral()}
                  className="flex-box-items-centralizados"
                >
                  <SearchIcon className="icon-search" />
                </Grid>

                <Grid
                  item
                  xs={2}
                  sm={2}
                  md={2}
                  lg={2}
                  xl={2}
                  onClick={() => setUserSideBarOpen(true)}
                  className="flex-box-items-centralizados nav-icon-user"
                >
                  <UserIcon className="nav-icon-user font-size-10" />
                </Grid>
              </>
            )}
          </Grid>

          <MenuDepartamentosMobile
            menuDepartamentoSideBar={menuDepartamentoSideBar}
            setMenuDepartamentoSideBar={setMenuDepartamentoSideBar}
            qtdIconeNotificacao={qtdIconeNotificacao}
            setAlertSideBarOpen={setAlertSideBarOpen}
            navegarParaConfiguracoes={navegarParaConfiguracoes}
            lstItensDepartamento={lstItensDepartamento}
            isPendingDepartamento={isPendingDepartamento}
            setDepartamentoSelecionado={setDepartamentoSelecionado}
            setMenuOpen={setMenuOpen}
          />
        </Toolbar>
      )}
    </AppBar>
  );
};

export default Navbar;
